var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
var allHours = [
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
];
var allMinutes = [
    '00',
    '05',
    '10',
    '15',
    '20',
    '25',
    '30',
    '35',
    '40',
    '45',
    '50',
    '55',
];
var TimePicker = function (props) {
    var className = props.className, defaultMin = props.defaultMin, defaultHour = props.defaultHour, minHour = props.minHour, onChange = props.onChange;
    var _a = __read(useState(defaultHour || '12'), 2), hour = _a[0], setHour = _a[1];
    var _b = __read(useState(defaultMin || '00'), 2), min = _b[0], setMin = _b[1];
    var handleHourChange = function (e) {
        setHour(e.target.value);
    };
    var handleMinChange = function (e) {
        setMin(e.target.value);
    };
    var availableHours = minHour ? allHours.filter(function (hour) { return parseInt(hour, 10) >= minHour; }) : allHours;
    useEffect(function () {
        onChange("".concat(hour, ":").concat(min));
    }, [hour, min, onChange]);
    var renderOption = function (opt) { return (React.createElement("option", { key: opt, value: opt }, opt)); };
    return (React.createElement("div", { className: className },
        React.createElement(Input, { type: "select", value: hour, onChange: handleHourChange, className: "mw-70 mr-1" }, availableHours.map(renderOption)),
        React.createElement(Input, { type: "select", value: min, onChange: handleMinChange, className: "mw-70" }, allMinutes.map(renderOption))));
};
TimePicker.propTypes = {
    className: PropTypes.string,
    defaultHour: PropTypes.string,
    defaultMin: PropTypes.string,
    minHour: PropTypes.number,
    onChange: PropTypes.func.isRequired,
};
export default TimePicker;
